import type { BreederListGetBreedersQuery } from '@gql/graphql';
import { useMemo } from 'react';
import { useFormatBreederCard } from '../../BreederListPageController/api/useFormatBreederCard';

export const useFormatBreeders = (
  breeders?: BreederListGetBreedersQuery['findManyDogBreeder'] | null,
) => {
  const { formatBreeder } = useFormatBreederCard();

  const formattedBreeders = useMemo(() => {
    if (!breeders?.length) return undefined;
    return breeders.map((breeder) => formatBreeder(breeder));
  }, [breeders, formatBreeder]);

  return { formattedBreeders, formatBreeder };
};
